import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=8c109712&scoped=true"
import script from "./CustomPagination.vue?vue&type=script&lang=js"
export * from "./CustomPagination.vue?vue&type=script&lang=js"
import style0 from "./CustomPagination.vue?vue&type=style&index=0&id=8c109712&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c109712",
  null
  
)

export default component.exports